module.exports = __webpack_public_path__ + "img/8.b7cac0a2.jpg";